<div class="container account-hero-section pb-5">
  <div id="hs-custom-preferences">&nbsp;</div>
  @if ((preferenceCenter$ | async) && (!urlParameters.data)) {
    <iframe frameBorder="0" [src]="urlSafe"></iframe>
  }

  @if ((preferenceCenter$ | async) === false) {
    <div class="row">
      <div class="col"></div>
      <div class="col-12 pr-3 pl-3 moveFromTop">
        <mdb-card>
          <app-inline-loader></app-inline-loader>
          <mdb-card-body>
            <div class="text-center">
              <h4>There is a problem with the URL supplied. Please call {{ branding.cs_phone_number }} for further assistance.</h4>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>
      <div class="col"></div>
    </div>
  }
</div>